// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1ii7183o{grid-row:1/2}\n._yyhy183o{grid-column:1/2}._1e0c11p5{display:grid}\n._2z051mfv{grid-template-rows:auto 1fr auto}\n._yv0ehkll{grid-template-columns:1fr}", ""]);
// Exports
module.exports = exports;
